import { render, staticRenderFns } from "./add-role.vue?vue&type=template&id=e330d2a2&scoped=true&"
import script from "./add-role.vue?vue&type=script&lang=ts&"
export * from "./add-role.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e330d2a2",
  null
  
)

export default component.exports